export const APP_CONFIG = {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:3001",
  APP_NAME: "Dom Belloni",
  APP_DESCRIPTION: "Sistema de Produção",
} as const;

export const COLORS = {
  PRIMARY: "#932018",
  PRIMARY_DARK: "#6b1712",
  SECONDARY: "#7a1a14",
  SECONDARY_DARK: "#5c140f",
  NEUTRAL_100: "#f3f4f6",
  NEUTRAL_200: "#e5e7eb",
  NEUTRAL_300: "#d1d5db",
  NEUTRAL_500: "#6b7280",
  NEUTRAL_900: "#111827",
  ERROR: "#ef4444",
  ERROR_LIGHT: "#fee2e2",
  ERROR_LIGHT_ALT: "#fecaca",
  ERROR_DARK: "#dc2626",
  ERROR_DARKER: "#b91c1c",
  SUCCESS: "#16a34a",
  ORANGE: "#ea580c",
  WHITE: "#ffffff",
  WHITE_SOFT: "#fff5f5",
  INFO: "#3b82f6",
  INFO_DARK: "#2563eb",
  WARNING_DARK: "#d97706",
  TEAL_DARK: "#0f766e",
  VIOLET: "#7c3aed",
  ROSE: "#be185d",
  EMERALD: "#047857",
  BLUE: "#1d4ed8",
  INDIGO: "#4338ca",
  AMBER: "#a16207",
  SKY: "#0369a1",
} as const;

export const SHADOWS = {
  selectFocusPrimary: "0 0 0 2px rgb(147 32 24 / 0.2)",
  selectFocusError: "0 0 0 2px rgb(239 68 68 / 0.2)",
} as const;

export const CHART_PALETTE = [
  COLORS.PRIMARY,
  COLORS.WARNING_DARK,
  COLORS.TEAL_DARK,
  COLORS.INFO_DARK,
  COLORS.VIOLET,
  COLORS.ROSE,
  COLORS.EMERALD,
  COLORS.ORANGE,
  COLORS.INDIGO,
  COLORS.AMBER,
  COLORS.ERROR_DARKER,
  COLORS.SKY,
] as const;

export const ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  LOJAS: "/lojas",
  USUARIOS: "/usuarios",
  METAS_COLETIVA: "/metas/coletiva",
  METAS_INDIVIDUAL: "/metas/individual",
} as const;

export const MASKS = {
  PHONE: "(99) 99999-9999",
  CNPJ: "99.999.999/9999-99",
  TIME: "99:99:99",
} as const;

export const MESSAGES = {
  CREATE: "Registro realizado.",
  UPDATE: "Registro atualizado.",
  DELETE: "Registro deletado.",
};
